import React from 'react';
import { IconMessageWrapper } from './iconMessageWrapper';
import { messages } from '@atlaskit/media-ui/messages';
import { FormattedMessage } from 'react-intl';
import { type InternalIconMessageProps, type CreatingPreviewProps } from './types';

export const IconMessage: React.FC<InternalIconMessageProps> = ({
	messageDescriptor,
	animated = false,
}) => {
	return (
		<IconMessageWrapper animated={animated}>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<span>
				<FormattedMessage {...messageDescriptor} />
			</span>
		</IconMessageWrapper>
	);
};

export const CreatingPreview: React.FC<CreatingPreviewProps> = ({ disableAnimation }) => (
	<IconMessage messageDescriptor={messages.creating_preview} animated={!disableAnimation} />
);

export const PreviewUnavailable: React.FC = (props) => (
	<IconMessage {...props} messageDescriptor={messages.preview_unavailable} />
);

export const FailedToLoad: React.FC = (props) => (
	<IconMessage {...props} messageDescriptor={messages.failed_to_load} />
);

export const FailedToUpload: React.FC = (props) => (
	<IconMessage {...props} messageDescriptor={messages.failed_to_upload} />
);

export const CheckInternetConnection: React.FC = (props) => (
	<IconMessage {...props} messageDescriptor={messages.check_internet_connection} />
);
